import {
  IAPIOccupancyRateReport,
  IOccupancyRateReportDashboard,
} from '../../../OccupancyRateReport/Client/IOccupancyRateReport'

class Transformer {
  static transform(
    report: IAPIOccupancyRateReport | null | undefined,
  ): IOccupancyRateReportDashboard[] {
    if (
      !report ||
      typeof report !== 'object' ||
      Object.keys(report).length === 0
    ) {
      return []
    }

    const occupancyResults: {
      [date: string]: IOccupancyRateReportDashboard
    } = {}

    for (const dateKey in report) {
      if (!Object.prototype.hasOwnProperty.call(report, dateKey)) {
        continue
      }

      const dateReport = report[dateKey]
      if (
        !dateReport ||
        typeof dateReport !== 'object' ||
        Object.keys(dateReport).length === 0
      ) {
        continue
      }

      for (const personUuid in dateReport) {
        if (!Object.prototype.hasOwnProperty.call(dateReport, personUuid)) {
          continue
        }

        const personData = dateReport[personUuid]
        if (
          !personData ||
          typeof personData !== 'object' ||
          typeof personData.working_minutes !== 'number' ||
          typeof personData.appointment_minutes !== 'number'
        ) {
          continue
        }

        if (!occupancyResults[dateKey]) {
          occupancyResults[dateKey] = {
            date: '0',
            workingMinutes: 0,
            appointmentMinutes: 0,
          }
        }

        occupancyResults[dateKey].date = dateKey

        occupancyResults[dateKey].workingMinutes += personData.working_minutes

        occupancyResults[dateKey].appointmentMinutes +=
          personData.appointment_minutes
      }
    }

    return Object.values(occupancyResults)
  }
}
export default Transformer
